import { Button, Card } from '@mairistem/composants';
import * as React from 'react';

import './ErrorFallback.css';

interface ErrorFallbackProps {
	error?: Error;
	resetError?: () => void;
}

const ErrorFallback = ({ error, resetError }: ErrorFallbackProps) => (
	<div className="error-fallback-container">
		<Card raised className="error-fallback-card">
			<Card.Header>
				<div className="error-fallback-title">Une erreur est survenue</div>
			</Card.Header>
			<Card.Content>
				<p className="error-fallback-message">
					{error?.message || "L'application a rencontré un problème inattendu."}
				</p>
				{resetError && (
					<Button
						className="error-fallback-button"
						primary
						fluid
						onClick={resetError}
					>
						Réessayer
					</Button>
				)}
			</Card.Content>
		</Card>
	</div>
);

export default ErrorFallback;
